import React from 'react';
import { Datagrid, TextField } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ListPageComum from '../../Components/ReactAdmin/List/ListPageComum';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PRIMARY_COLOR } from '../../utils/constants';
import { PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR } from '../../utils/dadosTelas';
import Filter from './Filter';

const useStyles = makeStyles(() => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const List = (props) => {
  const classes = useStyles();

  const toolbarActions = <ActionsList {...props} />;

  const renderGrid = () => (
    <Datagrid {...props}>
      <TextField
        source="nome"
        label="Produto"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        sortable={false}
      />
      <TextField
        source="codinomeColaboradorProduto.codinomeColaborador.nome"
        label="Codinome"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        sortable={false}
      />
    </Datagrid>
  );

  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR}>
      <ListPageComum
        title="Produtos Codinomes"
        filters={<Filter />}
        toolbarActions={toolbarActions}
        renderGrid={renderGrid}
        perPage={50}
        listProps={{ sort: { field: 'nome', order: 'asc' }, ...props }}
      />
    </ProtegerPagina>
  );
};

export default List;
